// Google Analytics 4 Integration
// To enable: Add your GA4 Measurement ID to .env as REACT_APP_GA_MEASUREMENT_ID

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

// Initialize Google Analytics
export const initGA = () => {
  if (!GA_MEASUREMENT_ID) {
    // GA not configured - skip initialization
    return;
  }

  // Add gtag script
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  // Initialize gtag
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  
  gtag('js', new Date());
  gtag('config', GA_MEASUREMENT_ID, {
    page_path: window.location.pathname,
    send_page_view: true
  });
};

// Track page views (call on route change)
export const trackPageView = (path) => {
  if (!GA_MEASUREMENT_ID || !window.gtag) return;
  
  window.gtag('config', GA_MEASUREMENT_ID, {
    page_path: path
  });
};

// Track custom events
export const trackEvent = (action, category, label, value) => {
  if (!GA_MEASUREMENT_ID || !window.gtag) return;
  
  window.gtag('event', action, {
    event_category: category,
    event_label: label,
    value: value
  });
};

// Pre-defined events for Étoile
export const analyticsEvents = {
  // User events
  userRegistered: () => trackEvent('sign_up', 'engagement', 'user_registered'),
  userLoggedIn: () => trackEvent('login', 'engagement', 'user_logged_in'),
  
  // Restaurant events
  restaurantViewed: (restaurantName) => trackEvent('view_item', 'restaurant', restaurantName),
  visitRecorded: (stars) => trackEvent('purchase', 'visit', `${stars}_star_visit`, stars),
  
  // Achievement events
  badgeEarned: (badgeName) => trackEvent('unlock_achievement', 'gamification', badgeName),
  achievementUnlocked: (achievementName) => trackEvent('unlock_achievement', 'gamification', achievementName),
  
  // Social events
  profileShared: () => trackEvent('share', 'social', 'profile_shared'),
  postCreated: () => trackEvent('create_content', 'community', 'post_created'),
  
  // Feature usage
  wishlistAdded: (restaurantName) => trackEvent('add_to_wishlist', 'engagement', restaurantName),
  reviewSubmitted: () => trackEvent('submit_review', 'engagement', 'review_submitted'),
  preferencesUpdated: () => trackEvent('update_preferences', 'engagement', 'preferences_updated'),
  
  // Export/Download
  profileExported: () => trackEvent('export', 'engagement', 'profile_exported_pdf')
};
